<template>
	<div>
		<v-row class="mb-0">
			<v-col sm="4" cols="12">
				<div class="image">
					<v-img
						max-width="100%"
						:src="product?.primaryImage?.url"
						class="rounded"
						alt="product"
					/>
				</div>
				<div class="d-flex flex-wrap justify-sm-start justify-center align-center mt-2 mb-4">
					<v-img
						v-for="(image, i) in productImages"
						:key="i"
						:width="140"
						:max-width="140"
						:height="140"
						:max-height="140"
						:src="image"
						class="rounded mx-1 mt-2"
						alt="product"
						style="cursor: pointer;"
						@click="
							lightBox.visible = true;
							lightBox.index = i;
						"
					/>
					<vue-easy-lightbox
						:visible="lightBox.visible"
						:imgs="productImages"
						:index="lightBox.index"
						@hide="lightBox.visible = false"
					></vue-easy-lightbox>
				</div>
			</v-col>
			<v-col sm="8" cols="12">
				<div class="d-flex flex-md-row flex-column-reverse flex-wrap justify-space-between align-md-center align-start">
					<h2>{{ product?.name }}</h2>
					<v-btn
						v-if="$vuetify.breakpoint.smAndUp"
						outlined
						exact
						class="pe-1"
						:to="{ name: 'home' }"
					>
						{{$t('back')}}
						<v-icon>mdi-chevron-{{$i18n.locale === 'ar' ? 'left': 'right'}}</v-icon>
					</v-btn>
				</div>
				<div
					v-html="product?.description"
					class="ck-content"
				></div>
			</v-col>
		</v-row>

		<div v-if="!$vuetify.breakpoint.smAndUp" class="text-center mb-3">
			<v-btn
				outlined
				exact
				class="ps-1"
				:to="{ name: 'home' }"
			>
				<v-icon>mdi-chevron-{{$i18n.locale === 'ar' ? 'right': 'left'}}</v-icon>
				{{$t('back')}}
			</v-btn>
		</div>

		<!-- related products -->
		<template v-if="false">
			<h2 class="my-2">{{ $t("related-products") }}</h2>
			<v-row class="row pt-5">
				<v-col
					v-for="product in products.filter(c => c.slug !== $route.params.slug).slice(0, 4)"
					:key="product.id"
					md="3"
					sm="4"
					cols="6"
				>
					<product-card :product="product"/>
				</v-col>
			</v-row>
		</template>
	</div>
</template>

<script>
import ProductCard from '@/components/ProductCard.vue';
import { mapGetters, mapState } from 'vuex';

export default {
	name: 'Product',

	components: { ProductCard },

	data() {
		return {
			lightBox: {
				visible: false,
				index: 0,
			}
		}
	},

	computed: {
		...mapState({
			products: state => state.products.products
		}),

		...mapGetters({
			getProductBySlug: 'products/getBySlug',
		}),

		product() {
			return this.getProductBySlug(this.$route.params.slug)
		},

		productImages() {
			return this.product
				?.images.filter(c => c.id !== this.product?.primaryImage?.id)
				.map(c => c.url) ?? []
		}
	},
};
</script>

<style lang="scss" scoped>
</style>
